import { useApp } from "../../../../services/app-context";
import { getLabel } from "../../utils/labels";
import StickWaveAudioPlayer from "./StickWaveAudioPlayer";

export function CallFlowQuestionView({ isManualReview, index, audioUrl, question, answer }: { isManualReview: boolean, index: number, audioUrl: string, question: string, answer: string }) {
    const { certificationAssets } = useApp();
    const labels = certificationAssets?.labels || {};
    return (
        <div className="border border-[#DFDFDF] rounded-[10px] flex flex-col gap-1.5 lg:w-[250px] xl:w-[350px] flex-1 2xl:flex-[0.65] 2xl:w-full desktop5:flex-[0.75]">
            <div className="border-b border-[#DFDFDF] p-2.5">
                <h1 className="text-[clamp(11px,1.5vw,15px)] uppercase font-medium tracking-[-0.14px] text-black">{getLabel("question.singular", labels)} and Response</h1>
            </div>
            <div className="px-2.5 pt-1 uppercase text-[clamp(10px,1.5vw,14px)] font-medium tracking-[0.3px] text-headerPrimary">{getLabel("question.singular", labels)}</div>
            <div className="text-[clamp(10px,1.5vw,14px)] px-2.5 text-black leading-[16px] border-b border-[#DFDFDF] pb-3 bg-white">{question}</div>
            <div className="px-2.5 uppercase text-[clamp(10px,1.5vw,14px)] font-medium tracking-[0.3px] text-headerPrimary pt-1">Response</div>
            <div className="px-2.5 py-2 bg-white">

                {isManualReview ?
                    (
                        <span className="text-[clamp(10px,1.5vw,14px)] leading-[16px] text-[##848484]">No Response Recorded</span>
                    ) : (
                        <>
                            <div>
                                <StickWaveAudioPlayer audioUrl={audioUrl} key={index} />
                            </div>
                            <div className="text-[clamp(10px,1.5vw,14px)] text-black max-h-[calc(100vh-575px)] overflow-y-auto py-1.5">
                                {answer}
                            </div>
                        </>)
                }
            </div>

        </div>
    )
}